import React from "react";
import {useTranslation} from "react-i18next";
import {SelectField} from "./FilterComponentStyles";

const PoolActivityFilter = ({
    value,
    onChange,
    showLabel = true,
    showAllOption = true,
    mode = undefined,
    selectMarginBottom = "20px",
    allowClear = false
}) => {
    const {t} = useTranslation();
    return (
        <React.Fragment>
            {showLabel && <h5>{"Havuz Aktiflik"}</h5>}
            <SelectField
                showSearch
                value={value}
                data-testid="pool_activity"
                mode={mode}
                onChange={onChange}
                mb={selectMarginBottom}
                allowClear={allowClear}
            >
                {showAllOption ? (
                    <SelectField.Option data-testid="available_rate_option" value={"all"}>
                        {t("filters.all", {ns: "common"})}
                    </SelectField.Option>
                ) : (
                    <></>
                )}
                <SelectField.Option data-testid="pool_activity_option" value={"active"}>
                    Aktif
                </SelectField.Option>
                <SelectField.Option data-testid="pool_activity_option" value={"inactive"}>
                    Pasif
                </SelectField.Option>
            </SelectField>
        </React.Fragment>
    );
};

export default PoolActivityFilter;
